import { render, staticRenderFns } from "./b8.vue?vue&type=template&id=6b2ee51b&scoped=true"
import script from "./b8.vue?vue&type=script&lang=js"
export * from "./b8.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2ee51b",
  null
  
)

export default component.exports